import { Badge, BlockStack, Button, Card, Divider, Grid, Icon, InlineStack, Link, Spinner, Text } from '@shopify/polaris';
import { AbandonedCartMajor, ClockMinor, DiamondAlertMinor, OrdersMinor, PackageFilledMajor, PackageMajor, RefundMinor, ReturnMinor, ShipmentMajor } from '@shopify/polaris-icons';
import React, { useMemo, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { renderStatusCount, timeSinceLastUpdate, usePreciseTimeAgo } from '../Utils/HelperFunc';
import { ordersFilter } from '../../NewAllSales/Utils/Constants';
import { useTranslation } from 'react-i18next';
import { PackageReturn } from '../../../../Asests/svgIcon/icon';

interface props extends DIProps {
    orderCount: any
    orderCountLoader: boolean
    getCount: (data?: boolean) => void,
    orderCountUpdateTime:string
}

const Orders = (props: props) => {
    const { t } = useTranslation();
    const { orderCount, orderCountLoader, getCount ,orderCountUpdateTime } = props;
    const pushtoOrder = (applied_filter: string) => {
        props.di.globalState.removeLocalStorage('orders_filter')

        let filters = JSON.parse(JSON.stringify(ordersFilter))

        if (applied_filter == 'Shipped') {
            filters['Status'] = {
                "value": "status",
                "textValue": t("Shipped"),
                "platform": "marketplace_status",
                "selectValue": "3",
                "label": "Amazon",
                "label2": t("Shipped"),
                "change": true
            }
        } else if (applied_filter == 'Cancelled') {
            filters['Sync Status'] = {
                "value": "cancelled",
                "textValue": t("Cancelled"),
                "selectValue": "1",
                "label": t("Cancelled"),
                "change": true
            }
        } else if (applied_filter == 'Refunded') {
            filters['Sync Status'] = {
                "value": "Refunded",
                "textValue": t("refund"),
                "selectValue": "3",
                "label": t("Refunded"),
                "change": true
            }
        }
        else if (applied_filter == 'Returns') {
            filters['Status'] = {
                "value": "status",
                "textValue": t("Failed"),
                "platform": "marketplace_status",
                "selectValue": "3",
                "label": "Amazon",
                "label2": t("Return"),
                "change": true
            }
        }

        else if (applied_filter == 'Errors') {
            return props.history('../allSales?error=true')


        }

        props.di.globalState.set('orders_filter', JSON.stringify(filters))
        props.history('../allSales')
    }

    const totalCount: any = renderStatusCount(orderCount?.total, orderCountLoader, t("Total orders"))
    // const totalBopisOrderCount: any = renderStatusCount(orderCount?.total_bopis_order_count, orderCountLoader, t("Local Selling"))

    const productStatus = [
        { id: 1, icon: ShipmentMajor, status: t('Shipped'), items: renderStatusCount(orderCount?.shipped_count, orderCountLoader) },
        { id: 2, icon: AbandonedCartMajor, status: t('Cancelled'), items: renderStatusCount(orderCount?.cancelled_count, orderCountLoader) },
        { id: 3, icon: RefundMinor, status: t('Refunded'), items: renderStatusCount(orderCount?.refund_count, orderCountLoader) },
        { id: 4, icon: DiamondAlertMinor, status: t('Errors'), items: renderStatusCount(orderCount?.errors, orderCountLoader) },
        // { id: 4, icon: PackageReturn, status: t('Returns'), items: renderStatusCount(orderCount?.national_failed_return, orderCountLoader) },
    ]

    const timeAgo = useMemo(() => timeSinceLastUpdate(orderCountUpdateTime), [orderCountUpdateTime]);
    return (
        <Card roundedAbove='sm'>
            <BlockStack gap="400">
                <BlockStack gap="200">
                    <InlineStack gap="200" align="space-between" blockAlign='center'>
                        <InlineStack gap="300" blockAlign='center'>
                            <Text variant="headingMd" as="h6">{t("Orders")}</Text>
                            <Badge size='large' icon={OrdersMinor} tone="attention">{totalCount}</Badge>
                        </InlineStack>
                        <InlineStack gap={'150'}>
                            <Text as='p' tone='subdued'>
                                <InlineStack>
                                    <Icon source={ClockMinor}></Icon>
                                    <Text as='p'>Last updated: {timeAgo}</Text>
                                </InlineStack>
                            </Text>
                            <Button onClick={() => getCount(true)}>{t("Refresh Now")}</Button>
                        </InlineStack>
                    </InlineStack>
                    <Divider></Divider>
                </BlockStack>
                <BlockStack gap="200">
                    <InlineStack gap="200" align="space-between" blockAlign='center'>
                        <Text variant="headingMd" as="h6" fontWeight='bold'>{t("Order Status")}</Text>
                        <Button variant='plain' onClick={() => props.history('../allSales')}>{t("Manage Orders")}</Button>
                    </InlineStack>
                    <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">
                        {t("Effectively handle orders that failed to sync on Shopify, encompassing regular orders in addition to refunds and cancellations.")}
                    </Text>
                </BlockStack>
                <BlockStack gap="300">
                    {/* <InlineStack align='start' blockAlign='center' gap="200">
                        <Badge size='large' icon={OrdersMinor}>{totalBopisOrderCount}</Badge>
                    </InlineStack> */}
                    <Card>
                        <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                            {productStatus.map(item => (
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} key={item.id}>
                                    <InlineStack blockAlign='start' gap="100">
                                        <div>
                                            <Icon source={item.icon} tone="base" />
                                        </div>
                                        <BlockStack gap="200">
                                            <Text as="p">{item.status}</Text>
                                            {
                                                orderCountLoader?
                                                <Spinner accessibilityLabel="Small spinner example" size="small" />:
                                                <Link removeUnderline onClick={() => pushtoOrder(item.status)} >{item.items}</Link>
                                            }

                                        </BlockStack>
                                    </InlineStack>
                                </Grid.Cell>
                            ))}
                        </Grid>
                    </Card>
                </BlockStack>
            </BlockStack>
        </Card>
    );
}

export default DI(Orders);